const TOKEN_KEY = 'aivideoclip_access_token';

const REFRESH_KEY = 'aivideoclip_refresh_token';

const USER_KEY = 'aivideoclip_user';



export function getAccessToken() {

  return localStorage.getItem(TOKEN_KEY) || '';

}



export function getRefreshToken() {

  return localStorage.getItem(REFRESH_KEY) || '';

}



export function setAuthSession(accessToken, user, refreshToken) {

  localStorage.setItem(TOKEN_KEY, accessToken || '');

  if (refreshToken) {

    localStorage.setItem(REFRESH_KEY, refreshToken);

  }

  localStorage.setItem(USER_KEY, JSON.stringify(user || null));

}



export function clearAuthSession() {

  localStorage.removeItem(TOKEN_KEY);

  localStorage.removeItem(REFRESH_KEY);

  localStorage.removeItem(USER_KEY);

}



export function getStoredUser() {

  try {

    const raw = localStorage.getItem(USER_KEY);

    return raw ? JSON.parse(raw) : null;

  } catch (e) {

    return null;

  }

}

